import React, { useState } from 'react';

export default function AimEmpty({ message = 'No data', height = 120, dismissible = true }) {
  const [dismissed, setDismissed] = useState(false);
  if (dismissed) return null;
  return (
    <div
      className="relative flex items-center justify-center text-sm text-gray-500 dark:text-gray-400 italic rounded-lg border border-dashed border-gray-200 dark:border-gray-800 bg-gray-50/50 dark:bg-gray-900/30"
      style={{ minHeight: height }}
    >
      {dismissible && (
        <button
          type="button"
          onClick={() => setDismissed(true)}
          aria-label="Dismiss"
          className="absolute top-2 right-2 opacity-50 hover:opacity-100 text-xs leading-none p-1 not-italic"
        >
          ✕
        </button>
      )}
      <span className={dismissible ? 'px-6' : ''}>{message}</span>
    </div>
  );
}

export function AimLoading({ height = 120 }) {
  return (
    <div
      className="rounded-lg border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 p-4 animate-pulse"
      style={{ minHeight: height }}
      role="status"
      aria-label="Loading"
    >
      <AimSkeletonBars />
    </div>
  );
}

export function AimSkeletonBars({ lines = 4 }) {
  const widths = ['w-1/3', 'w-2/3', 'w-1/2', 'w-3/4', 'w-5/6'];
  return (
    <div className="space-y-2.5">
      {Array.from({ length: lines }).map((_, i) => (
        <div
          key={i}
          className={`h-3 rounded bg-gray-200 dark:bg-gray-800 ${widths[i % widths.length]}`}
        />
      ))}
    </div>
  );
}

export function AimError({ message = 'Something went wrong', onRetry, dismissible = true }) {
  const [dismissed, setDismissed] = useState(false);
  if (dismissed) return null;
  return (
    <div role="alert" className="rounded-lg border border-red-200 dark:border-red-900 bg-red-50 dark:bg-red-950/30 p-3 text-sm text-red-700 dark:text-red-300 flex items-center justify-between gap-3">
      <span className="flex-1">{message}</span>
      <div className="flex items-center gap-2 shrink-0">
        {onRetry && (
          <button
            type="button"
            onClick={onRetry}
            className="px-2 py-1 rounded bg-red-100 dark:bg-red-900/40 hover:bg-red-200 dark:hover:bg-red-900/60 text-xs font-medium"
          >
            Retry
          </button>
        )}
        {dismissible && (
          <button
            type="button"
            onClick={() => setDismissed(true)}
            aria-label="Dismiss"
            className="opacity-60 hover:opacity-100 text-sm leading-none p-1"
          >
            ✕
          </button>
        )}
      </div>
    </div>
  );
}
